<div *ngIf="form" [formGroup]="form">
  <app-auto-complete-list-group
    (selectChange)="onSelectChange($event)"
    (searchChange)="onSearchChange($event)"
    [removeSelectedItem]="removedItem"
    [externalSelectedItemsData]="this.form.controls.itemsFromFile.value"
    [itemsData]="students"
    [selectedItemsData]="form.controls.items.value"
    [inputTitle]="'ADD_STUDENT' | translate"
  ></app-auto-complete-list-group>
  <app-form-error [control]="form.controls.items"></app-form-error>

  <div *ngIf="shouldShowFileUploader || shouldShowGroupSelection" class="d-flex py-2">
    <!-- File uploader visibility toggle -->
    <ng-container *ngIf="shouldShowFileUploader">
      <div class="ml-auto">
        <button
          type="button"
          [ngClass]="!shouldShowFileUploaderArea ? 'btn btn-meta' : 'btn btn-meta active'"
          (click)="setVisiblityOfFileUploader(!shouldShowFileUploaderArea)"
        >
          <i class="icon ftmi-upload"></i> {{ 'FROM_CSV' | translate }}
        </button>
      </div>
    </ng-container>

    <!-- Group selection visibility toggle -->
    <ng-container *ngIf="shouldShowGroupSelection">
      <div>
        <button
          type="button"
          [ngClass]="!shouldShowGroupSelectionArea ? 'btn btn-meta' : 'btn btn-meta active'"
          (click)="setVisiblityOfGroupSelection(!shouldShowGroupSelectionArea)"
        >
          <i class="icon ftmi-roster"></i> {{ 'FROM_GROUP' | translate }}
        </button>
      </div>
    </ng-container>
  </div>

  <!-- File uploader -->
  <ng-container *ngIf="shouldShowFileUploader && shouldShowFileUploaderArea">
    <div class="mt-4">
      <app-file-uploader (fileChange)="onFileChange($event)" [getPrefix]="false"></app-file-uploader>
    </div>
    <ng-container>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <a class="btn btn-text" target="_blank" [href]="rosterCsvTemplate">
          <i class="ftmi-download"></i> {{ 'DONWLOAD_EXAMPLE_FILE' | translate }}
        </a>
        <div class="d-flex">
          <button
            class="btn btn-outline-primary btn-sm mr-2"
            type="button"
            (click)="setVisiblityOfFileUploader(!shouldShowFileUploaderArea)"
          >
            {{ 'CLOSE' | translate }}
          </button>
          <button
            class="btn btn-primary btn-sm"
            type="button"
            [disabled]="!form.controls.manualFile.value || form.controls.manualFile.errors || isUploading"
            (click)="onFileUpload()"
          >
            <span *ngIf="isUploading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ 'UPLOAD' | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <input class="d-none" formControlName="manualFile" />
    <app-form-error [control]="form.controls.manualFile"></app-form-error>
  </ng-container>

  <!-- Group select add/remove actions -->
  <ng-container *ngIf="shouldShowGroupSelection && shouldShowGroupSelectionArea">
    <div class="meta-panel mb-2">
      <form method="post">
        <div class="form-group" appParentValidator [control]="form.controls.groupSelect">
          <div class="app-input">
            <label for="selectGroup"> {{ 'SELECT_GROUP' | translate }}</label>
            <app-auto-complete
              (selectedItemChange)="onSelectChangeRoster($event)"
              (searchChange)="onSearchChangeRoster($event)"
              [selectedItem]="form.controls.groupSelect.value"
              [itemsData]="groups"
              [searchOnClick]="true"
              [minTermLength]="0"
            ></app-auto-complete>
          </div>
          <app-form-error [control]="form.controls.groupSelect"></app-form-error>
        </div>
        <div class="form-group d-flex">
          <div class="custom-control custom-radio mr-4">
            <input
              type="radio"
              id="addGroupToList"
              name="groupsAction"
              class="custom-control-input"
              (change)="updateGroupSelectActionState(rosterSelectActions.Add)"
              [checked]="form.controls.groupSelectAction.value === rosterSelectActions.Add"
            />
            <label class="custom-control-label custom-control-label-sm" for="addGroupToList">{{
              'ADD_TO_LIST' | translate
            }}</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="removeGroupFromList"
              name="groupsAction"
              class="custom-control-input"
              (change)="updateGroupSelectActionState(rosterSelectActions.Remove)"
              [checked]="form.controls.groupSelectAction.value === rosterSelectActions.Remove"
            />
            <label class="custom-control-label custom-control-label-sm" for="removeGroupFromList">{{
              'REMOVE_FROM_LIST' | translate
            }}</label>
          </div>
          <app-form-error [control]="form.controls.groupSelectActionState"></app-form-error>
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-end align-items-center mb-4">
      <button
        class="btn btn-outline-primary btn-sm mr-2"
        type="button"
        (click)="setVisiblityOfGroupSelection(!shouldShowGroupSelectionArea)"
      >
        {{ 'CLOSE' | translate }}
      </button>
      <button
        class="btn btn-primary btn-sm"
        type="button"
        [disabled]="form.controls.groupSelectActionState.errors"
        (click)="onGroupSelectAction()"
      >
        {{ 'APPLY' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- List of selected items -->
  <div *ngIf="form.controls.items.value !== null && form.controls.items.value.length !== 0">
    <ul class="list-group list-group-remove">
      <li *ngFor="let item of form.controls.items.value" class="list-group-item">
        <b class="mr-3">{{ item?.extraLabels?.firstLabel }} {{ item?.extraLabels?.secondLabel }}</b>
        {{ item?.extraLabels?.thirdLabel }}
        <span class="ml-auto">
          <span class="round-btn round-btn-xs list-group-action ml-2" (click)="onRemove(item)"
            ><i class="ftmi-cross"></i
          ></span>
        </span>
      </li>
    </ul>
    <div class="list-group-count">
      {{ 'SELECTED_STUDENTS' | translate }} : <span class="counter">{{ form.controls.items.value.length }}</span>
    </div>
  </div>
  <div *ngIf="form.controls.items.value === null || form.controls.items.value.length === 0" class="empty-list-message">
    {{ 'ROSTER_LIST_EMPTY_MESSAGE' | translate }}
  </div>
</div>
